// Toggle the menu open and close when on mobile
export default function tabs() {
    const tabsLinks = document.querySelectorAll('.tabs-link');
    const tabsContents = document.querySelectorAll('.tabs-content');
    tabsLinks.forEach((link, index) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            tabsContents.forEach(content => {
                content.classList.remove('active');
            });
            tabsContents[index].classList.add('active');
            tabsLinks.forEach(tabLink => {
                tabLink.classList.remove('active-title');
            });
            link.classList.add('active-title');
        });
    });
}
